import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import EmailService from '../../services/EmailService';
import Spinner from '../Spinner'; // Optional loading spinner
import Swal from 'sweetalert2';

const EmailList = () => {
  const [emails, setEmails] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchEmails();
  }, []);

  const fetchEmails = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await EmailService.getAll();
      setEmails(data);
    } catch (err) {
      console.error('Error fetching emails:', err);
      setError('Failed to fetch emails. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this email?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
    });

    if (result.isConfirmed) {
      try {
        // Implement the delete API call here
        // await EmailService.delete(id);
        Swal.fire('Deleted!', 'Email deleted successfully.', 'success');
        fetchEmails(); // Refresh the list
      } catch (error) {
        console.error('Error deleting email:', error);
        Swal.fire('Error!', 'Failed to delete email. Please try again.', 'error');
      }
    }
  };

  const filteredEmails = emails.filter((email) =>
    email.recipient_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">Email List</h4>
              <p className="card-description">Manage email recipients</p>

              {/* Add New Button */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <Link to="/emails/create" className="btn btn-primary btn-sm">
                  <i className="ti-plus menu-icon"></i> Add New Email
                </Link>
                <input
                  type="text"
                  className="form-control form-control-sm w-50"
                  placeholder="Search emails..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>

              {/* Emails Table */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Recipient Name</th>
                    <th>Recipient Email</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredEmails.length > 0 ? (
                    filteredEmails.map((email) => (
                      <tr key={email.id}>
                        <td>{email.recipient_name}</td>
                        <td>{email.recipient_email}</td>
                        <td>
                          <Link
                            to={`/emails/edit/${email.id}`}
                            className="btn btn-sm btn-primary mr-2"
                          >
                            Edit
                          </Link>
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => handleDelete(email.id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center">
                        No emails found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="card-footer text-muted">
              Showing {filteredEmails.length} of {emails.length} emails
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailList;
